import React from "react";
import { constants } from "@qgiv/core-js";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { filterClassificationsBasedOnPresetsOrUserSelections } from "@qgiv/p2p-registration";
import { selectAllClassifications } from "../../../redux/slices/classificationsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import {
    selectAllRaceConditions,
    setUnsetSelectedClassification,
} from "../../../redux/slices/raceConditionsSlice";
import {
    selectRegistrationsFromRegistration,
    updateRegistration,
} from "../../../redux/slices/registrationSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import Classifications from "./Classifications";
import { selectTeams } from "../../../redux/slices/teamsSlice";
import { selectAllCategories } from "../../../redux/slices/categoriesSlice";

const ConnectedClassifications = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const dispatch = useDispatch();

    const classifications = useSelector(selectAllClassifications);
    const p2pSettings = useSelector(selectAllP2pSettings);
    const { classificationLabel, limitTeamJoiningToClassification } =
        p2pSettings;
    const raceConditions = useSelector(selectAllRaceConditions);
    const { unsetSelectedClassification = false } = raceConditions;
    const registrations = useSelector(selectRegistrationsFromRegistration);
    const teams = useSelector(selectTeams);
    const categories = useSelector(selectAllCategories);
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_CLASSIFICATION_STEP,
            state,
        ),
    );

    const {
        options: {
            sectionHeading = "Choose a %ClassificationLabel%:",
            additionalText = "",
        },
    } = control;

    const classificationsProps = {
        classifications: filterClassificationsBasedOnPresetsOrUserSelections({
            categories,
            classifications,
            teams,
            registrations,
            limitTeamJoiningToClassification,
        }),
        sectionHeading: sectionHeading.replace(
            "%ClassificationLabel%",
            classificationLabel === "" ? "Classification" : classificationLabel,
        ),
        additionalText,
        controlId,
        unsetSelectedClassification,
        registrations,
        setUnsetSelectedClassification,
        updateRegistration,
        dispatch,
    };
    return <Classifications {...classificationsProps} />;
};

ConnectedClassifications.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedClassifications;
